import React from "react";
import { getUserToken } from "../../service/AuthService";
import { Navigate, Outlet } from "react-router-dom";


const PrivateRoute = () => {
 const auth = getUserToken();

  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  return auth ? <Outlet /> : <Navigate to="/signin" />;
};
 export default PrivateRoute